const minin = {
  computed: {
    // 是否显示驳回按钮
    showRejectBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      // console.log(this.order.isstatus != 3 || this.order.isover != 2, boo)
      const data = { ...this.order, ...this.detail }
      if (data.isstatus != 3 || data.isover != 2) return boo
      if (this.user && data.isfleet != 2) {
        if ([5].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
    // 是否显示审核按钮
    showExamineBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      // console.log(this.order.isstatus != 3 || this.order.isover != 2, boo)
      const data = { ...this.order, ...this.detail }
      if (data.isstatus != 3 || data.isover != 2) return boo
      if (this.user && data.isfleet != 2) {
        if ([5].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
  },
  data() {
    return {
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
      ],
      formCtrlOrder0: [],
      formCtrlOrder: [
        {
          label: "加油方式",
          keyName: "gsid",
          err: "请选择加油方式",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "现金加油(元)",
          keyName: "doil",
          err: "请填写现金加油",
          type: "number",
          viewMode: true,
        },
        {
          label: "非现金加油(元)",
          keyName: "moneydoil",
          err: "请填写油气费",
          type: "number",
          viewMode: true,
          className: "unton",
        },
        {
          label: "现金票据",
          keyName: "moneyphoto",
          type: "file",
          ptype: "daypay",
          //className: "block",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "非现金票据",
          keyName: "photo",
          type: "file",
          ptype: "daypay",
          //className: "block",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
          className: "unton",
        },
        {
          label: "开始里程数",
          keyName: "ksmileage",
          err: "请填写开始里程数",
          type: "number",
          viewMode: true,
        },
        {
          label: "结束里程数",
          keyName: "jsmileage",
          err: "请填写结束里程数",
          type: "number",
          viewMode: true,
          className: "unton",
        },
        {
          label: "开始里程单据",
          keyName: "ksmileagephoto",
          type: "file",
          ptype: "daypay",
          //className: "block",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "结束里程单据",
          keyName: "jsmileagephoto",
          type: "file",
          ptype: "daypay",
          //className: "block",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
          className: "unton",
        },
      ],
      formCtrl2: [
        {
          label: "出车费用票据",
          keyName: "cost_images",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          type: "textarea",
          viewMode: true,
          className: "block",
          rows: 4,
        },
        {
          label: "合计",
          keyName: "total",
          type: "number",
          viewMode: true,
          className: "block",
        },
        // {
        //   label: "司机填写",
        //   keyName: "isover",
        //   type: "select",
        //   viewMode: true,
        //   className: "block",
        //   options: [
        //     { label: '未完成', value: 1 },
        //     { label: '已完成', value: 2 },
        //   ],
        // },
      ],
      getDataUrl: 'money',
      submitUrl: 'examinemoney',
      dayauth: [],
      order: {},
      // 里程单位价格
      unitprice: 0,
      rejectCtrl: {
        label: "驳回原因",
        keyName: "reject_reason",
        type: "textarea",
        viewMode: true,
        className: "block",
        rows: 4,
      },
    };
  },
  methods: {
    paramsPackage(params, object) {
      // console.log({ ...params })
      // console.log({ ...object })
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && !['driver', 'shname', 'isstatus', 'is_reject', 'reject_reason'].includes(key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else if (key.includes('isnum') || ['doil', 'moneydoil', 'volume'].includes(key)) {
            params[key] = value || 0
          } else {
            params[key] = value;
          }
        }
      }
      // console.log('params', {...params})
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      // 所有配置费用项
      const arr = this.dayauth.map(v => v.enname)
      //console.log(arr)
      // 加上油气费
      const arr1 = [...arr, 'doil', 'moneydoil', 'jsmileage', 'ksmileage']
      if (value && typeof value === 'object') {
        if (value.length) {
          this.form[key] = value.map(v => {
            let result = v
            if (v.response && v.response.photo) {
              result = { url: v.response.photo }
            }
            return result
          })
        } else {
          this.form[key] = null
        }
      } else if (arr1.includes(key) && key != "volume") {
        this.form[key] = value;
        // 实时计算总额
        this.$nextTick(() => {
          let dtotal = 0
          const object = { ...this.form }
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key) && key.includes('isnum')) {
              const element = object[key];
              // console.log(element)
              dtotal += Number(element)
            }
          }
          const { doil, moneydoil, jsmileage, ksmileage } = this.form
          if (this.form.jsmileage != 0) {
            dtotal += Number(doil) + Number(moneydoil) + (Number(jsmileage) - Number(ksmileage)) * this.unitprice
          } else {
            dtotal += Number(doil) + Number(moneydoil)
          }
          // console.log(dtotal)
          this.form.total = dtotal.toFixed(2)
          this.$forceUpdate()
        })
      } else {
        this.form[key] = value;
      }
      console.log({ ...this.form });
    },
    setDetail() {
      const {
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      } = this.order
      this.form = {
        ...this.detail,
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      }
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    setDetailOrderData({ dayauth, gasstation, order, unitprice }) {
      this.order = { ...order }
      // 里程单位价格
      this.unitprice = Number(unitprice) || 0
      this.dayauth = dayauth
      dayauth.map(v => {
        const key = v.enname
        if (Object.hasOwnProperty.call(this.detail, key)) {
          let label = v.authname + '(元)'
          if (v.authname === '加油量') {
            label = v.authname + '(升)'
            this.formCtrlOrder0.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
              className: "unton",
            })
          } else {
            this.formCtrlOrder.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
            })
          }
        }
      })
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'gsid' && gasstation.length) {
          c.options = gasstation.map(v => {
            return {
              label: v.gasname,
              value: v.id,
            }
          })
          // console.log(c.options)
        }
      })
      this.$forceUpdate()
      // console.log([...this.formCtrlOrder])
    },
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt('', '驳回原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.rejectReq(value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    rejectReq(reject_reason) {
      this.loading = true
      let url = `order/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '驳回成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '驳回失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.formCtrl2.slice(1)
  },
}

export default minin